<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Ola-Yimika is an author with a cause. His mission is to write highly insightful materials filled with proven strategies that motivate others to discover their purpose, find their perennial success, maximise their productivity and fulfil their potential in life. He believes in the core values of self-discipline, diligence, integrity and a value-added mentality.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?fb24f234